import { AppRemixIcon } from '@/layout/AppComponents';

export default function AppButton(props) {
  const {
    children,
    icon,
    color = 'primary',
    className = '',
    disabled = false,
    outline = false,
    title = '',
    size = 'sm',
    onClick = () => {},
  } = props;

  return (
    <span
      className={`d-inline-flex align-items-center btn btn-${size} btn${
        outline ? '-outline' : ''
      }-${color} ${className} ${disabled ? 'disabled' : ''}`}
      onClick={!disabled ? onClick : () => {}}
      title={title}
    >
      {icon && <AppRemixIcon icon={icon} className="mr-1" />}
      {children}
    </span>
  );
}
